import { useMemo } from 'react';
import { FormControlHook, useFormControl } from './formControl';

/*
 **
 ** ---------> Memorization is VITAL for these <---------------------
 **
 */

type FormControlActions<State> = Omit<FormControlHook<State>, 'state'>;

interface ControlOptions {
  watch?: boolean;
}

export function useFormControlV2<State extends object>(
  defaultValues: State,
  options: ControlOptions = {},
): [State, FormControlActions<State>] {
  const { state, ...actions } = useFormControl(defaultValues, options);

  const memorizedActions = useMemo(
    () => ({
      ...actions,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return [state, memorizedActions];
}
